import { createSelector } from 'reselect';
import type { Location } from '../../../../types/locations.tsx';
import type { State, LocationsState, ContextState } from '../model.tsx';

const contextSelector = (state: State): ContextState => state.context;
const locationsSelector = (state: State): LocationsState => state.locations;

export const userSelector = createSelector(
	locationsSelector,
	(locations: LocationsState) => locations.user,
);

export const projectsSelector = createSelector(
	locationsSelector,
	(locations: LocationsState) => locations.projects,
);

export const isPendingSelector = createSelector(
	projectsSelector,
	(projects: Location[]) => !projects || projects.length <= 0,
);

export const recentProjectsLimitSelector = createSelector(
	contextSelector,
	(context: ContextState) => context.recentProjectsLimit,
);
